module.exports = __webpack_public_path__ + "static/media/canLeadToHeartAttack.c2bbefe9.mp3";